type Move = {start: number, end: number};

type BoxesObserver = ((boxes: number[] | null) => void) | null;
type MovesObserver = ((moves: Move[] | null) => void) | null;
type PawnPositionObserver = ((pawnPosition: number[] | null) => void) | null;
type SelectedPawnObserver = ((selectedPawn: number | null) => void) | null;
type PlayerTurnObserver = ((playerTurn: number | null) => void) | null;

export class Game {
    public boxes: number[];
    public moves: Move[];
    public pawnPosition: number[];
    public pawnContainer: number[][];
    public selectedPawn: number | null = null;
    public playerTurn: number = 0;
    public winner: number | null = null;
    readonly playerName: string[] = ["Player 1", "Player 2"];

	private boxesObserver: BoxesObserver = null;
	private movesObserver: MovesObserver = null;
	private pawnPositionObserver: PawnPositionObserver = null;
	private selectedPawnObserver: SelectedPawnObserver = null;
	private playerTurnObserver: PlayerTurnObserver = null;

    public constructor(boxes: number[], moves: Move[], pawnPosition: number[]){
        this.boxes = boxes;
        this.moves = moves;
        this.pawnPosition = pawnPosition;
        this.playerTurn = 0;
        this.selectedPawn = null;
        this.winner = null;

        this.constructPawnContainer();
    }

    public setNewGame(boxes: number[], moves: Move[], pawnPosition: number[]){
        this.boxes = boxes;
        this.moves = moves;
        this.pawnPosition = pawnPosition;
        if(this.boxesObserver !== null) this.boxesObserver([...this.boxes]);
        if(this.movesObserver !== null) this.movesObserver([...this.moves]);
        if(this.pawnPositionObserver !== null) this.pawnPositionObserver([...this.pawnPosition]);

        this.playerTurn = 0;
        this.selectedPawn = null;
        this.winner = null;

        this.constructPawnContainer();

        if(!this.canMove()){
            this.winner = 1;
            return;
        }
    }

	public observeBoxes(observer: BoxesObserver){
        this.boxesObserver = observer;
	}

	public observeMoves(observer: MovesObserver){
        this.movesObserver = observer;
	}

	public observePawnPosition(observer: PawnPositionObserver){
        this.pawnPositionObserver = observer;
	}

	public observeSelectedPawn(observer: SelectedPawnObserver){
        this.selectedPawnObserver = observer;
	}

    public observePlayerTurn(observer: PlayerTurnObserver){
        this.playerTurnObserver = observer;
	}

    private constructPawnContainer(){
        this.pawnContainer = [];
        for(let i = 0; i < this.boxes.length; i++) this.pawnContainer.push([]);
        for(let i = 0; i < this.pawnPosition.length; i++) this.pawnContainer[this.pawnPosition[i]].push(i);
    }

    public movePawn(nextBoxId: number): void {
        if(this.selectedPawn === null || this.pawnPositionObserver === null) return;

        this.pawnPosition[this.selectedPawn] = nextBoxId;
        this.constructPawnContainer();
        this.pawnPositionObserver([...this.pawnPosition]);
        
        if(this.playerTurnObserver === null) return;

        if(!this.canMove()){
            this.winner = this.playerTurn;
            return;
        }
        
        this.playerTurn = 1 - this.playerTurn;
        this.playerTurnObserver(this.playerTurn);
    }

    public canMove(){
        let canMove: boolean = false;
        for(const pawn of this.pawnPosition) canMove = canMove || pawn !== 0;
        return canMove;
    }

    public canMovePawn(nextBoxId: number): boolean {
        if(this.selectedPawn === null) return false;

        const selectedPawnBoxId = this.pawnPosition[this.selectedPawn];
        if(selectedPawnBoxId === 0) return false;

        return this.moves[selectedPawnBoxId - 1].start <= nextBoxId && nextBoxId <= this.moves[selectedPawnBoxId - 1].end;
    }

    public setSelectedPawn(pawnId: number){
        this.selectedPawn = pawnId;

        if(this.selectedPawnObserver === null) return;
        this.selectedPawnObserver(this.selectedPawn);
    }
}